import React, { useState, useEffect } from "react";

const Courasel = ({
  children,
  direction,
  flex,
  duration,
  getIndex,
  delay,
  arrows,
}) => {
  const [currentIndex, setIndex] = useState(0);

  const setCurrentIndex = (newIndex) => {
    if (newIndex < 0) {
      newIndex = React.Children.count(children) - 1;
    } else if (newIndex >= React.Children.count(children)) {
      newIndex = 0;
    }
    setIndex(newIndex);
  };

  const [paused, setPaused] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      if (!paused) {
        setCurrentIndex(currentIndex + 1);
      }
    }, delay);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  });

  if(getIndex !== undefined){
    getIndex(currentIndex)
  }


  const reactChildren = React.Children.toArray(children);
  return (
    <div className="overflow-hidden">
      <div
        onMouseEnter={() => setPaused(!paused)}
        onMouseLeave={() => setPaused(!paused)}
        className={`mt-1 flex flex-${flex} duration-${duration}`}
        style={{ transform: `translate${direction}(-${currentIndex * 100}%)` }}
      >
        {React.Children.map(children, (child, index) => {
          return React.cloneElement(
            child,
            index === currentIndex
              ? { transform: "scale(95)" }
              : { transform: "scale(100)" }
          );
        })}
      </div>
      <div
        className={`${arrows} flex-row items-center justify-center space-x-4 mt-5`}
      >
        {reactChildren.map((child, i) => (
          <p
            onClick={() => setCurrentIndex(reactChildren.indexOf(child))}
            className={`cursor-pointer rounded-full duration-${duration} px-3 py-[6px] ${
              reactChildren.indexOf(child) === currentIndex
                ? `bg-brandColor px-6`
                : `bg-transparent border`
            }`}
            key={i}
          ></p>
        ))}
      </div>
    </div>
  );
};

export default Courasel;
